import {
  ContentText,
  DailyLogContent,
} from 'src/app/common/components/daily-log-content-text/daily-log-content-text.component'
import { objToCamelCase } from './case-styles'

export const DEFAULT_FONT_SIZE = 18
export const DEFAULT_CONTENT: DailyLogContent = {
  globalStyle: { 'font-family': 'Pretendard-Regular', 'font-size': `${DEFAULT_FONT_SIZE}px`, 'text-align': 'center' },
  texts: [],
}

/** TextEditor content형태의 JSON string 여부 */
export const isDailyLogContentString = (str: string): boolean => {
  try {
    const parsed = JSON.parse(str)
    // 파싱된 값이 객체이거나 배열일 경우에만 JSON으로 간주. + 필수 property가지고 있어야함
    return (
      typeof parsed === 'object' &&
      parsed !== null &&
      parsed.hasOwnProperty('globalStyle') &&
      parsed.hasOwnProperty('texts')
    )
  } catch (e) {
    return false
  }
}

export const extractTextFromTextEditorContent = (value: DailyLogContent | string): string => {
  if (typeof value === 'string') {
    if (isDailyLogContentString(value)) {
      return convertTextEditorStringToObject(value).texts.reduce((acc, cur) => acc + cur.value, '')
    }
    return value
  }
  return value.texts.reduce((acc, cur) => acc + cur.value, '')
}

export const convertTextEditorStringToObject = (str: string): DailyLogContent => {
  if (isDailyLogContentString(str)) {
    const result: DailyLogContent = JSON.parse(str)
    result.texts = result.texts.reduce((acc, cur) => {
      if (cur.value.includes('\n')) {
        acc.push(
          ...cur.value
            .split(/(\n)/)
            .filter(Boolean)
            .map((value) => ({ value, style: cur.style }))
        )
        return acc
      }
      acc.push(cur)
      return acc
    }, [] as ContentText[])
    return result
  } else {
    return {
      ...DEFAULT_CONTENT,
      texts: str
        .split(/(\n)/)
        .filter(Boolean)
        .map((value) => ({ value, style: {} })),
    }
  }
}

export const convertGlobalStyleToRNObj = (globalStyle: { [key: string]: string }) => {
  return removePx(objToCamelCase(globalStyle))
}

const removePx = (obj: Record<string, any>): Record<string, any> => {
  return Object.keys(obj).reduce((acc, key) => {
    const value = obj[key]
    // 값이 문자열이고 'px'로 끝나면 숫자로 변환
    acc[key] = typeof value === 'string' && value.endsWith('px') ? parseFloat(value) : value
    return acc
  }, {} as Record<string, any>)
}
